<!-- 审核通过的销售退货单 -->
<template>
	<el-dialog  title="选择销售退货单"  :visible.sync="dialogVisible"  width="90%" center append-to-body top="2rem">
		<subComponents  ref="showSelectData"></subComponents>
		<div class='components_content_box'>
			<!-- <div class="page_content_top">
				<div class="page_content_top_line">
					<el-form :inline="true" :model="getRequestData" class="demo-form-inline"  size="mini" >
						<el-form-item label="退回单位" >
							<el-input v-model.trim="getRequestData.cmName" clearable @focus="$refs['showSelectData'].openBox('customerList','customerList','cmId')">
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div> -->
			<div class="page_content_center">
				<el-table ref="multipleTable"  stripe :data="returnData.list" border @row-dblclick="selectDataAction"   style="width: 100%" highlight-current-row>
					<el-table-column type="expand" label="详情" width="80">
					    <template slot-scope="props">
							<el-tabs type="border-card">
								<el-tab-pane label="辅助信息" >
									<el-table :data="[props.row.desuRgapplySupInfo]"  border  style="width: 100%">
										<el-table-column prop="coName" label="货主"></el-table-column>
										<el-table-column prop="rgaiAccperiod" label="账期"></el-table-column>
										<el-table-column prop="rgaiDismode" label="配送方式"></el-table-column>
										<el-table-column prop="rgaiPaymode" label="付款方式"></el-table-column>
										<el-table-column prop="rgaiSetmode" label="结算方式"></el-table-column>
									</el-table>
								</el-tab-pane>
								<el-tab-pane label="明细" >
									<el-table :data="props.row.desuRgapplyDetails"  height="400px"    border  style="width: 100%">
										<el-table-column prop="bgmName" label="通用名称" min-width="200" fixed="left" :show-overflow-tooltip="true">
										</el-table-column>
										<el-table-column prop="bgmManufacturer" label="生产厂家	"></el-table-column>
										<el-table-column prop="bgmPlaceorigin" label="产地"></el-table-column>
										<el-table-column prop="rgadBatnumber" label="批号"></el-table-column>
										<el-table-column prop="bgmSpecifications" label="规格"></el-table-column>
										<el-table-column prop="rgadSbnumber" label="灭菌批号"></el-table-column>
										<el-table-column prop="rgadOldnumber" label="原单数量"></el-table-column>
										<el-table-column prop="returnNum" label="已退货数量"></el-table-column>
										<el-table-column prop="rgadRetnumber" label="退回数量"></el-table-column>
										<el-table-column prop="rgadPrice" label="单价"></el-table-column>
										<el-table-column prop="rgadMoney" label="金额"></el-table-column>
										<el-table-column prop="rgadPsprice" label="含税价格"></el-table-column>
										<el-table-column prop="rgadPsmoney" label="含税金额"></el-table-column>
										<el-table-column prop="rgadOuttaxrate" label="销项税率"></el-table-column>
										<el-table-column prop="rgadProdate" label="生产日期" >
											<template  slot-scope="scope">
												<div v-if="scope.row.rgadProdate">
													{{$common.getLocalTime(scope.row.rgadProdate)}}
												</div>
											</template>
										</el-table-column>
										<el-table-column prop="rgadEffdate" label="有效期" >
													{{$common.getLocalTime(scope.row.rgadProdate)}}
											<template  slot-scope="scope">
												<div v-if="scope.row.rgadEffdate">
													{{$common.getLocalTime(scope.row.rgadEffdate)}}
												</div>
											</template>
										</el-table-column>
									</el-table>
								</el-tab-pane>
							</el-tabs>
					    </template>
					</el-table-column>
					<el-table-column prop="depName"   label="业务部门">
					</el-table-column>
					<el-table-column prop="opmName"   label="业务员">
					</el-table-column>
					<el-table-column prop="cmName"   label="退回单位">
					</el-table-column>
					<el-table-column prop="rgamTotalnumber"   label="总数量">
					</el-table-column>
					<el-table-column prop="rgamTotalcount"   label="总条目数">
					</el-table-column>
					<el-table-column prop="rgamTotalmoney"   label="总金额">
					</el-table-column>
					<el-table-column prop="rgamRapdate"   label="申请日期">
						<template  slot-scope="scope">
							<div v-if="scope.row.rgamRapdate">
								{{$common.getLocalTime(scope.row.rgamRapdate)}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="rgamRemark"   label="备注">
					</el-table-column>
				</el-table>
			</div>
			<div class="page_content_bottom">
				<el-pagination
					background
					@size-change="setDataPageSize"
					@current-change="setDataPageNumber"
					:current-page="getRequestData.page"
					:page-sizes="[30,50,100,500]"
					:page-size="30"
					layout="total, sizes, prev, pager, next, jumper"
					:total="returnData.total">
				</el-pagination>
			</div>
		</div>
	</el-dialog>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	name:'salesReturnOrderTemplate',
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			dialogVisible:false,
			getRequestData:{
				rgamRapcus:'',
				cmName:'',
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			pageShowData:[],
			formDataList:[],
			expands:[],
			selectedDetailsList:[],
			getRowKeys(row) { // 行数据的Key
			    return row.wobkemId
			},
			
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
		'getRequestData.cmName':{
			handler:function(newValue,oldValue){
				if(newValue==''){
					this.getRequestData.rgamRapcus = ''
				}
			},
			deep:true,
		}
	},
	//方法集合
	methods: {
		isShowData(name,value){
			switch(name){
				case 'customerList':
					var dataInfo = sessionStorage.getItem('selectCustomerData')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.getRequestData.rgamRapcus = dataInfo.cmId
						this.getRequestData.cmName = dataInfo.cmName
					}
					
				break;
				
				default:
					this.getRequestData[name] = value
				
			}
		},
	
		selectDataAction(row, column, event){
			this.dialogVisible = false
			this.$parent.extractData(row)
		},
		
		openBox(){
			// this.getPageInfo()
			this.getDataList()
			this.dialogVisible = true
			this.selectedDetailsList = []
		},
	
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getSalesReturnOrderYesList(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
            this.$refs.multipleTable.doLayout();
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.table_content_tag{
	margin-right: 1rem;
}
.el-tabs--border-card_new{
	height: 85vh;
	overflow-y: scroll;
}
</style>
